import { useAccessLevel } from '../context/AccessLevelContext'
import { AppFunction } from './roles'

export const useFilteredNavigation = (navigation: any[]) => {
  const { isAuthorized } = useAccessLevel()

  const filterNav = (items: any[]): any[] => {
    return items
      .map((item) => {
        if (item.children) {
          const filteredChildren = filterNav(item.children)
          return filteredChildren.length > 0
            ? { ...item, children: filteredChildren }
            : null
        }
        const hasAccess =
          !item.requiredFunction ||
          isAuthorized(item.requiredFunction as AppFunction)

        return hasAccess ? item : null
      })
      .filter(Boolean)
  }

  return filterNav(navigation)
}
